export const setExperimentSession = (
  experimentName: string,
  uniqueId: string,
  value: string
): void => {
  typeof window !== 'undefined' &&
    window.sessionStorage.setItem(`exp-session-${experimentName}-${uniqueId}`, value);
};

export const getExperimentSession = (experimentName: string, uniqueId: string): string | null => {
  return typeof window !== 'undefined'
    ? window.sessionStorage.getItem(`exp-session-${experimentName}-${uniqueId}`)
    : null;
};
